const subtypeOptions = (type, { interestTagsEnabled = true } = {}) => {
  const filterInterest = (options) =>
    interestTagsEnabled
      ? options
      : options.filter((o) => o.value !== "topicOfInterest");

  switch (type) {
    case "people":
      return filterInterest([
        { label: "Category of user", value: "categoryOfUser" },
        { label: "Topic of interest", value: "topicOfInterest" },
      ]);
    case "session":
      return [
        { label: "Dress code", value: "dressCode" },
        { label: "Session type", value: "sessionType" },
        { label: "Topic", value: "topic" },
      ];
    default:
      return filterInterest([
        { label: "Category of user", value: "categoryOfUser" },
        { label: "Topic of interest", value: "topicOfInterest" },
        { label: "Dress code", value: "dressCode" },
        { label: "Session type", value: "sessionType" },
        { label: "Topic", value: "topic" },
      ]);
  }
};
export default subtypeOptions;
